
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Voeg het toe aan je startscherm voor een uitgebreide ervaring en gemakkelijke toegang.`,
's1b9047d53d9f9d22': `2) Druk op delen in de navigatiebalk`,
's37a9e8aec5713460': `Meer`,
's5c6aad7a7e4a1437': `3) Druk op Toevoegen aan het startscherm`,
's6196153c4b0c1ea0': `Installeren`,
's922329d6f6213590': `Toevoegen aan Dock`,
'sa5ef80b4bb9b39f8': `Minder`,
'sa7551383d1897fcc': `2) Druk op Toevoegen aan Dock`,
'sba52286c21552a4e': `Installeer het op je apparaat voor een uitgebreide ervaring en gemakkelijke toegang.`,
'sc79fd7641eb9a975': `Instructie verbergen`,
'scdaf4bbff76674c8': `Toevoegen aan het startscherm`,
'sdfe23506a3b0cdc8': `1) Open in Safari-browser`,
'se740f75b95a51807': `Voeg het toe aan je Dock voor een uitgebreide ervaring en makkelijke toegang.`,
'sfea652f6580ff086': `Deze site heeft app-functionaliteit.`,
    };
  